<template>
    <a-modal :title="$t('hotel.invoice_parameters_configuration', { value: modalName } /*   发票参数配置- */)" :visible="visible" :width="'70%'" @ok="handleOk" @cancel="handleCancel">
        <a-spin tip="Loading..." :spinning="loading">
            <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol" style="overflow-x: auto">
                <h3 style="border-bottom: 1px solid rgb(235, 237, 240); background: #f7f7f7; font-size: 15px; text-align: center; padding: 10px 0; border-radius: 5px">
                    {{ $t('hotel.enterprise_basic_info' /* 企业基本信息 */) }}
                </h3>

                <a-form-item :hidden="true" class="mb15">
                    <a-input v-decorator="['channel_id']" />
                </a-form-item>
                <a-form-item class="mb15 mt15" :label="$t('hotel.enterprise_name' /* 企业名称 */)">
                    <a-input
                        v-decorator="[
                            'company_name',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: $t('hotel.enter_enterprise_name' /* 请输入企业名称 */)
                                    }
                                ]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.taxpayer_identification_number' /* 纳税人识别号 */)">
                    <a-input v-decorator="['taxpayer_identification_number']" />
                    <div slot="extra" class="error-color">{{ $t('hotel.tip_api_invoice' /* 注意：如需接口开票此项必填 */) }}</div>
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.enterprise_business_address' /* 企业经营地址 */)">
                    <a-input
                        v-decorator="[
                            'business_address',
                            {
                                rules: [{ validator: fpInfoComplete }]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.enterprise_phone' /* 企业电话 */)">
                    <a-input
                        v-decorator="[
                            'contact_tel',
                            {
                                rules: [{ validator: fpInfoComplete }]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.enterprise_bank' /* 企业开户行 */)">
                    <a-input
                        v-decorator="[
                            'bank_name',
                            {
                                rules: [{ validator: fpInfoComplete }]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.enterprise_bank_account' /* 企业开户行账号 */)">
                    <a-input
                        v-decorator="[
                            'bank_account',
                            {
                                rules: [{ validator: fpInfoComplete }]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.taxpayer_category' /* 纳税人类别 */)">
                    <a-radio-group v-decorator="['tax_rete_type_id']">
                        <a-radio value="0">{{ $t('hotel.small_scale_taxpayer' /* 小规模纳税人 */) }}</a-radio>
                        <a-radio value="1">{{ $t('hotel.general_taxpayer' /* 一般纳税人 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.tax_rate' /* 税率 */)">
                    <a-checkbox-group
                        v-decorator="[
                            'tax_rete_info',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: $t('hotel.enter_enterprise_name' /* 请输入企业名称 */)
                                    }
                                ]
                            }
                        ]"
                    >
                        <template v-for="(item, index) in suilvList">
                            <a-checkbox v-if="form.getFieldValue('tax_rete_type_id') == item.payer_id" :key="index" :value="String(item.id)">{{ item.front_name }}</a-checkbox>
                        </template>
                    </a-checkbox-group>
                </a-form-item>

                <a-form-item class="mb15" :label="$t('hotel.payee' /* 收款人 */)">
                    <a-input v-decorator="['payee']" />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.reviewer' /* 复核人 */)">
                    <a-input v-decorator="['checker']" />
                </a-form-item>
                <a-form-item class="mb15" :label="$t('hotel.invoicer' /* 开票人 */)">
                    <a-input v-decorator="['drawer']" />
                </a-form-item>

                <h3 style="border-bottom: 1px solid rgb(235, 237, 240); background: #f7f7f7; font-size: 15px; text-align: center; padding: 10px 0; border-radius: 5px">
                    {{ $t('hotel.invoice_collection_rules' /* 发票收集规则 */) }}
                    <span class="error-color">{{ $t('hotel.tip_invoice_collection' /* 注意：提交发票数据会根据配置规则验证是否合格 */) }}</span>
                </h3>

                <a-form-item class="mb15" :label="$t('hotel.restrict_invoice_title' /* 是否限制发票抬头必须和用户单位一致 */)">
                    <a-radio-group v-decorator="['is_unit']">
                        <a-radio value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                        <a-radio value="0">{{ $t('formConfig.yes' /* 否 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item v-show="form.getFieldValue('is_unit')" class="mb15" :label="$t('hotel.allow_vague_match' /*是否允许发票抬头与用户单位模糊匹配 */)">
                    <a-radio-group v-decorator="['is_vague']">
                        <a-radio value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                        <a-radio value="0">{{ $t('formConfig.yes' /* 否 */) }}</a-radio>
                    </a-radio-group>
                    <div slot="extra" class="error-color">{{ $t('hotel.tip_vague_match' /* 允许后发票抬头包含用户单位或者用户单位包含发票抬头都可以验证通过 */) }}</div>
                </a-form-item>

                <a-form-item class="mb15" :label="$t('hotel.invoice_title_blacklist' /* 发票抬头黑名单 */)">
                    <a-textarea :placeholder="$t('hotel.enter_invoice_title_blacklist' /* 请输入发票抬头黑名单 */)" v-decorator="['blacklist']" />

                    <div slot="extra" class="error-color">{{ $t('hotel.tip_blacklist_keywords' /* 多个关键词用|隔开，例如：个人|公司|有限 */) }}</div>
                </a-form-item>

                <a-form-item class="mb15" :label="$t('hotel.invoice_title_whitelist' /* 发票抬头白名单 */)">
                    <a-textarea :placeholder="$t('hotel.enter_invoice_title_whitelist' /* 请输入发票抬头白名单 */)" v-decorator="['whitelist']" />
                    <div slot="extra" class="error-color">{{ $t('hotel.tip_whitelist_keywords' /* 多个关键词用|隔开，如果是多个词组成词直接用+串联起来；例如：医院+公司|大学+公司 */) }}</div>
                </a-form-item>

                <a-form-item class="mb15" :label="$t('hotel.tax_number_length_rule' /* 税号位数限制规则 */)">
                    <a-checkbox-group v-decorator="['tax_number']">
                        <a-checkbox value="18">{{ $t('hotel.digits', { num: 18 }) /* 位 */ }}</a-checkbox>
                        <a-checkbox value="15">{{ $t('hotel.digits', { num: 15 }) /* 位 */ }}</a-checkbox>
                        <a-checkbox value="17">{{ $t('hotel.digits', { num: 17 }) /* 位 */ }}</a-checkbox>
                        <a-checkbox value="20">{{ $t('hotel.digits', { num: 20 }) /* 位 */ }}</a-checkbox>
                    </a-checkbox-group>
                </a-form-item>

                <h3 style="border-bottom: 1px solid rgb(235, 237, 240); background: #f7f7f7; font-size: 15px; text-align: center; padding: 10px 0; border-radius: 5px">
                    {{ $t('hotel.invoice_info_collection_default' /* 发票信息收集默认配置 */) }}
                    <span class="error-color">{{ $t('hotel.tip_invoice_info_default' /* 注意：此项为默认配置，项目审核选择此渠道会默认把配置同步到项目中 */) }}</span>
                </h3>

                <a-form-item class="mb15" :label="$t('hotel.open_invoice_info_collection' /* 是否开通发票信息收集 */)">
                    <a-switch :checked-children="$t('formConfig.yes' /* 是 */)" :un-checked-children="$t('formConfig.no' /* 否 */)" v-decorator="['is_open_inv', { valuePropName: 'checked' }]" />
                </a-form-item>

                <div v-show="form.getFieldValue('is_open_inv')">
                    <a-form-item class="mb15" :label="$t('hotel.optional_invoice_types' /* 可选发票类型 */)">
                        <a-checkbox-group v-decorator="['inv_type']">
                            <a-checkbox value="5">{{ $t('hotel.vat_electronic_invoice' /* 增值税普通电子发票 */) }}</a-checkbox>
                            <a-checkbox value="2">{{ $t('hotel.vat_special_invoice' /* 增值税专用发票 */) }}</a-checkbox>
                            <a-checkbox value="1">{{ $t('hotel.vat_paper_invoice' /* 增值税普通纸质发票 */) }}</a-checkbox>
                            <a-checkbox value="4">{{ $t('hotel.fixed_amount_invoice' /* 定额发票 */) }}</a-checkbox>
                            <a-checkbox value="6">{{ $t('hotel.fiscal_receipt' /* 财政票据 */) }}</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>

                    <a-form-item class="mb15" :label="$t('hotel.required_invoice_info' /* 是否必填发票信息 */)">
                        <a-switch
                            :checked-children="$t('formConfig.yes' /* 是 */)"
                            :un-checked-children="$t('formConfig.no' /* 否 */)"
                            v-decorator="['invoice_display', { valuePropName: 'checked' }]"
                        />
                    </a-form-item>

                    <a-form-item class="mb15" :label="$t('hotel.allow_personal_invoice' /* 是否允许开个人发票 */)">
                        <a-switch
                            :checked-children="$t('formConfig.yes' /* 是 */)"
                            :un-checked-children="$t('formConfig.no' /* 否 */)"
                            v-decorator="['allowed_personal', { valuePropName: 'checked' }]"
                        />
                    </a-form-item>

                    <a-form-item class="mb15" :label="$t('hotel.collect_invoice_mailing_info' /* 是否收集发票邮寄信息 */)">
                        <a-switch :checked-children="$t('formConfig.yes' /* 是 */)" :un-checked-children="$t('formConfig.no' /* 否 */)" v-decorator="['receive_type', { valuePropName: 'checked' }]" />
                    </a-form-item>

                    <div v-if="lang == 'en'">
                        <a-form-item class="mb15" :label="$t('hotel.hotel_receipt_download' /* 酒店费收据下载 */)">
                            <a-switch
                                :checked-children="$t('formConfig.yes' /* 是 */)"
                                :un-checked-children="$t('formConfig.no' /* 否 */)"
                                v-decorator="['receipt_dow', { valuePropName: 'checked' }]"
                            />
                        </a-form-item>

                        <a-form-item class="mb15" :label="$t('hotel.hotel_receipt_template' /* 酒店费收据模板 */)">
                            <a-upload
                                :action="uploadImageUrl"
                                :file-list="fileList"
                                :before-upload="info => beforeUpload(info, 'file', ['docx', 'doc'])"
                                :headers="uploadHeaders"
                                :remove="
                                    () => {
                                        form.setFieldsValue({ receipt_tpl: '' });
                                    }
                                "
                                @change="info => handleFileChange(info, { fileList: 'fileList', field: 'receipt_tpl' })"
                            >
                                <input type="hidden" v-decorator="['receipt_tpl']" />
                                <a-button>
                                    <a-icon type="upload"></a-icon>
                                    {{ $t('hotel.download_sample' /* 上传文件 */) }}
                                </a-button>
                            </a-upload>
                            <div slot="extra">
                                {{ $t('hotel.tip_receipt_template' /* 建议文件小于3M，支持doc、docx格式 */) }}
                                <a style="color: #5181f1" target="_blank" href="https://www.sciconf.cn/download/英文收据模板.docx">
                                    {{ $t('hotel.download_english_receipt_template' /* 英文收据模板下载 */) }}
                                </a>
                            </div>
                        </a-form-item>

                        <a-form-item class="mb15" :label="$t('hotel.tag_info' /* 标签信息 */)">
                            <a-row :gutter="[20]">
                                <a-col v-for="(item, index) in tagList" :key="index" :sm="12" :md="8">
                                    <a-button type="link">{{ item }}</a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                    </div>
                </div>

                <h3 style="border-bottom: 1px solid rgb(235, 237, 240); background: #f7f7f7; font-size: 15px; text-align: center; padding: 10px 0; border-radius: 5px">
                    {{ $t('hotel.electronic_invoice_default' /* 电子发票默认配置 */) }}
                    <span class="error-color">{{ $t('hotel.tip_electronic_invoice_default' /* 注意：此项为默认配置，项目审核选择此渠道会默认把配置同步到项目中 */) }}</span>
                </h3>

                <a-form-item class="mb15" :label="$t('hotel.enable_electronic_invoice_management' /* 是否启用电子发票管理 */)">
                    <a-radio-group v-decorator="['is_open']">
                        <a-radio value="0">{{ $t('hotel.disable_electronic_invoice' /* 否，不支持开具电子发票 */) }}</a-radio>
                        <a-radio value="1">{{ $t('hotel.enable_electronic_invoice' /* 是，支持在线开具电子发票 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <div v-show="form.getFieldValue('is_open') == 1">
                    <a-form-item class="mb15" :label="$t('hotel.hotel_personal_offline_invoice' /* 酒店个人【线下支付】开票 */)">
                        <a-radio-group v-decorator="['per_offline']">
                            <a-radio value="0">{{ $t('hotel.not_allow_electronic_invoice' /* 不允许申请电子发票 */) }}</a-radio>
                            <a-radio value="1">{{ $t('hotel.user_apply_admin_issue' /* 用户可申请【管理员开具】电子发票 */) }}</a-radio>
                            <a-radio value="2">{{ $t('hotel.auto_issue_after_payment' /* 用户缴费后自动开发票（只支持电子发票） */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item class="mb15" :label="$t('hotel.hotel_personal_online_invoice' /* 酒店个人【线上支付】开票 */)">
                        <a-radio-group v-decorator="['per_online']">
                            <a-radio value="1">{{ $t('hotel.user_apply_admin_issue' /* 用户可申请【管理员开具】电子发票 */) }}</a-radio>
                            <a-radio value="2">{{ $t('hotel.auto_issue_after_payment' /* 用户缴费后自动开发票（只支持电子发票） */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item class="mb15" :label="$t('hotel.hotel_team_offline_invoice' /* 酒店团队【线下支付】开票 */)">
                        <a-radio-group v-decorator="['team_offline']">
                            <a-radio value="0">{{ $t('hotel.not_allow_electronic_invoice' /* 不允许申请电子发票 */) }}</a-radio>
                            <a-radio value="1">{{ $t('hotel.user_apply_admin_issue' /* 用户可申请【管理员开具】电子发票 */) }}</a-radio>
                            <a-radio value="2">{{ $t('hotel.auto_issue_after_payment' /* 用户缴费后自动开发票（只支持电子发票） */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item class="mb15" :label="$t('hotel.hotel_team_online_invoice' /* 酒店团队【线上支付】开票 */)">
                        <a-radio-group v-decorator="['team']">
                            <a-radio value="0">{{ $t('hotel.not_allow_electronic_invoice' /* 不允许申请电子发票 */) }}</a-radio>
                            <a-radio value="1">{{ $t('hotel.user_apply_admin_issue' /* 用户可申请【管理员开具】电子发票 */) }}</a-radio>
                            <a-radio value="2">{{ $t('hotel.auto_issue_after_payment' /* 用户缴费后自动开发票（只支持电子发票） */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item class="mb15" :label="$t('hotel.invoice_remark_display' /* 发票备注显示形式 */)">
                        <a-radio-group v-decorator="['inv_notetype']">
                            <a-radio value="0">{{ $t('hotel.custom_remark' /* 自定义 */) }}</a-radio>
                            <a-radio value="1">{{ $t('hotel.fixed_remark' /* 固定显示 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="form.getFieldValue('inv_notetype') == 0" class="mb15" :label="$t('hotel.invoice_remark_info' /* 发票备注信息 */)">
                        <a-textarea :placeholder="$t('hotel.enter_invoice_remark_info' /* 请输入发票备注信息 */)" v-decorator="['remark']" />
                        <div slot="extra" class="error-color">{{ $t('hotel.tip_invoice_remark' /* 票面备注信息，如果不填写，票面展示为空，如果填入则根据填入信息填入票面信息！ */) }}</div>
                    </a-form-item>
                    <a-form-item class="mb15" :label="$t('hotel.hotel_receipt_template' /* 酒店费收据模板 */)">
                        <a-upload
                            :action="uploadImageUrl"
                            :file-list="fileList2"
                            :before-upload="info => beforeUpload(info, 'file', ['docx'])"
                            :headers="uploadHeaders"
                            :remove="
                                () => {
                                    form.setFieldsValue({ commitment: '' });
                                }
                            "
                            @change="info => handleFileChange(info, { fileList: 'fileList2', field: 'commitment' })"
                        >
                            <input type="hidden" v-decorator="['commitment']" />
                            <a-button>
                                <a-icon type="upload"></a-icon>
                                {{ $t('hotel.download_sample' /* 上传文件 */) }}
                            </a-button>
                            <p>
                                <a href="https://www.sciconf.cn/download/申请更换发票承诺函.docx" target="_blank">
                                    <a-button type="link">{{ $t('hotel.download_sample' /* 下载样例 */) }}</a-button>
                                </a>
                            </p>
                        </a-upload>
                        <div slot="extra">{{ $t('formConfig.upload_doc_file' /* 请上传后缀为.docx类型的文档 */) }}</div>
                    </a-form-item>
                </div>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
const fields = [
    'channel_id',
    'company_name',
    'taxpayer_identification_number',
    'business_address',
    'contact_tel',
    'bank_name',
    'bank_account',
    'tax_rete_type_id',
    'payee',
    'checker',
    'drawer',
    'is_unit',
    'is_vague',
    'blacklist',
    'whitelist',
    'tax_number',
    'is_open_inv',
    'inv_type',
    'invoice_display',
    'allowed_personal',
    'receive_type',
    'receipt_dow',
    'receipt_tpl',
    'is_open',
    'per_offline',
    'per_online',
    'team_offline',
    'team',
    'inv_notetype',
    'tax_rete_info',
    'remark',
    'commitment'
];
import userApi from '@/request/apiList';
import pick from 'lodash.pick';
import * as judgeType from '@/utils/judgeDataType';
export default {
    name: 'InvoiceParams',
    components: {},
    data() {
        return {
            visible: false,
            loading: false,
            form: this.$form.createForm(this),
            labelCol: { xs: 24, md: 8, lg: this.$route.params.lang == 'cn' ? 6 : 7 },
            wrapperCol: { xs: 24, md: 14, lg: 16 },
            modalName: '',
            tagList: [
                '用户姓名：${real_name}',
                '用户性别：${sex}',
                '省份名称：${province_name}',
                '城市名称：${city_name}',
                '单位名称：${org_enname}',
                '缴费时间：${back_time}',
                '缴费日期：${back_date}',
                '酒店日期：${reg_date}',
                '科室：${department}',
                '酒店号：${reg_no}',
                '酒店信息：${reg_info}',
                '酒店信息：${hotel_info}',
                '稿件信息：${abstract_info}',
                '实际支付金额：${back_money}',
                '应付金额：${total_money}',
                '币种：${money_type}',
                '支付方式：${pay_abbreviation}',
                '称谓：${en_cwtitle}',
                '名：${given_name}',
                '姓：${family_name}',
                '单位地址：${address}',
                '家庭地址：${family_address}',
                '生日：${birthdate}',
                '邮件：${email}',
                '单位邮编：${zipcode}',
                '国家：${country_name}',
                '护照号码：${passport}',
                '性别：${sex_en}',
                '稿件id：${abstract_ids}'
            ],
            // 上传地址
            uploadImageUrl: userApi.uploadImage,
            // 请求头
            uploadHeaders: {},
            // 图片上传LOADING
            imageLoading: false,

            // 文件上传受控列表
            fileList: [],
            fileList2: [],
            lang: 'cn',
            suilvList: [] // 税率列表
        };
    },
    methods: {
        // 自定义验证 【发票完整性】
        fpInfoComplete(rule, value, callback) {
            const form = this.form;
            // 企业开户行账号
            var bank_account = form.getFieldValue('bank_account'),
                // 企业开户行
                bank_name = form.getFieldValue('bank_name'),
                // 企业电话
                contact_tel = form.getFieldValue('contact_tel'),
                // 企业经营地址
                business_address = form.getFieldValue('business_address');
            if (!value && (bank_account || bank_name || contact_tel || business_address)) {
                callback(this.$t('hotel.please_fill_in_complete_invoice_information' /* 请您填写完整的发票信息 */));
            } else {
                callback();
            }
        },

        show(record) {
            this.visible = true;
            this.lang = record.language;
            this.modalName = record.channel_name;
            this.$nextTick(() => {
                fields.forEach(v => this.form.getFieldDecorator(v));
                this.getDataInfo(record);
            });
        },
        getDataInfo(data) {
            this.loading = true;
            this.$request
                .get({
                    url: 'getHotelChannelInvInfo',
                    data: {
                        language: data.language,
                        channel_id: data.channel_id
                    }
                })
                .then(res => {
                    res.data['channel_id'] = data.channel_id;
                    this.suilvList = res.data.tax;
                    for (let key in res.data) {
                        if (key == 'tax_number') {
                            res.data[key] = res.data[key].split('|').filter(it => String(it));
                        }
                        if (key == 'inv_type') {
                            res.data[key] = res.data[key].split(',').filter(it => String(it));
                        }
                        if (key == 'tax_rete_info') {
                            res.data[key] = res.data[key].split(',').filter(it => String(it));
                        }
                        if (['is_open_inv', 'invoice_display', 'allowed_personal', 'receive_type', 'receipt_dow'].indexOf(key) != -1) {
                            res.data[key] = res.data[key] == 1 ? true : false;
                        }
                        if (key == 'receipt_tpl' && res.data[key]) {
                            this.fileList = [
                                {
                                    uid: -1,
                                    name: res.data[key],
                                    status: 'done',
                                    url: res.data[key]
                                }
                            ];
                        }
                        if (key == 'commitment' && res.data[key]) {
                            this.fileList2 = [
                                {
                                    uid: 1,
                                    name: res.data[key],
                                    status: 'done',
                                    url: res.data[key]
                                }
                            ];
                        }
                        if (judgeType.isNumber(res.data[key])) {
                            res.data[key] = String(res.data[key]);
                        }
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(pick(res.data, fields));
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 上传前
        beforeUpload(file, type, file_type) {
            return new Promise((resolve, reject) => {
                let regFile = true;
                // 头像的验证
                if (type == 'image') {
                    let regFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
                    if (!regFile) {
                        this.$message.error(this.$t('formConfig.only_upload_image' /* 您只能上传图像文件 */));
                        return resolve(regFile);
                    }
                }
                // 其他文件的验证
                if (type == 'file') {
                    // 取后台上传的后缀配置
                    // let options = currItem.options || [];
                    let options = file_type || ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx'];
                    // 获取当前上传的文件后缀
                    let suffix = file.name.split('.');
                    suffix = suffix[suffix.length - 1];

                    if (options.length && options.indexOf(suffix) == -1) {
                        regFile = false;
                        this.$message.error(this.$t('formConfig.please_upload_file', { type: options.join('|') } /* 请上传后缀为{type}的格式 */));
                        return resolve(regFile);
                    }
                }
                return resolve(regFile);
            });
        },
        // 上传文件修改
        handleFileChange(info, config) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            // 2. read from response and show file link
            fileList = fileList.map(file => {
                if (file.response) {
                    let { code, data, message } = file.response;
                    if (code == 200) {
                        file.url = data.relative_path;
                        this.form.setFieldsValue({ [config.field]: file.url });
                    } else {
                        this.$message.error(message);
                        file.status = 'error';
                    }
                }
                return file;
            });
            this[config.fileList] = fileList;
        },
        handleOk() {
            // 获取表单
            this.form.validateFields((err, values) => {
                if (!err) {
                    for (let key in values) {
                        if (judgeType.isBool(values[key])) {
                            values[key] = Number(values[key]);
                        }
                    }
                    let data = {
                        language: this.lang,
                        ...values
                    };
                    this.loading = true;
                    this.$request
                        .post({ url: 'setHotelChannelInvEdit', data })
                        .then(res => {
                            if (res.code == 200) {
                                this.$message.success(this.$t('formConfig.save_success' /* 保存成功 */));
                                this.handleCancel();
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    },
    created() {},
    destroyed() {
        this.fileList = [];
        this.fileList2 = [];
    },
    mounted() {
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
    }
};
</script>

<style lang="less" scoped></style>
